import axiosInstance from "../../axiosInstance.js";
import { baseUrl } from "../../endpoints.js";
import { configReq } from "../../../lib/functions.js";

/** Keeps the existing GET request and response contract. */
export function getRequest(url, inputValue, token) {
  return axiosInstance(`${baseUrl}/${url}?page=1&Limit=${inputValue ? 200 : 20}&search=${inputValue}`, configReq(token));
}
